/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Button } from '@coursera/cds-core';
import { ShareIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/sharing-common';

type Props = {
  isDark?: boolean;
  buttonText?: string;
};

export default ({ buttonText, isDark }: Props) => {
  const svgColor = isDark ? '#FFFFFF' : '#0056D2';
  const buttonVariant = isDark ? 'ghostInvert' : 'ghost';

  return (
    <Button
      data-testid="ShareCTAV2"
      variant={buttonVariant}
      size="small"
      iconPosition="before"
      icon={<ShareIcon size="small" stroke={svgColor} strokeWidth=".25" />}
      className="rc-ShareCTAV2"
    >
      {buttonText || _t('Share')}
    </Button>
  );
};
